import { AnimatePresence, motion } from 'framer-motion'
import React, { useState } from 'react'
import { HiMenuAlt4, HiX } from 'react-icons/hi'

import { v4 as rid } from 'uuid'
import { images } from '../../constants'
import { CONTAINER_TITLE } from '../../constants/enum'
import './Navbar.scss'

const Navbar = () => {
  const [toggle, setToggle] = useState(false)

  return (
    <nav className="app__navbar">
      <div className="app__navbar-logo">
        <a href="#Intro">
          <img src={images.logo} alt="logo" />
        </a>
      </div>
      <ul className="app__navbar-links">
        {CONTAINER_TITLE.map(item => (
          <li className="app__flex p-text" key={`container_link_${rid()}`}>
            <div className="app__navbar-dot" />
            <a href={`#${item}`}>{item}</a>
          </li>
        ))}
      </ul>

      <div className="app__navbar-menu">
        <HiMenuAlt4 onClick={() => setToggle(true)} />

        <AnimatePresence
          exitBeforeEnter
          mode="wait"
          onExitComplete={() => null}>
          {toggle && (
            <motion.div
              layout
              variants={{
                visible: {
                  x: 0,
                  transition: { duration: 0.35, ease: 'easeOut' },
                },
                hidden: {
                  x: '100%',
                  transition: { duration: 0.35, ease: 'easeOut' },
                },
              }}
              initial="hidden"
              animate="visible"
              exit="hidden">
              <HiX onClick={() => setToggle(false)} />
              <ul>
                {CONTAINER_TITLE.map(item => (
                  <li key={`container_link_mb_${rid()}`}>
                    <a href={`#${item}`} onClick={() => setToggle(false)}>
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </nav>
  )
}

export default Navbar
